import React, { Component } from "react";
import config from "react-global-configuration";
import RequestApi from "../Miscelania/RequestApi";

import { Link, Redirect } from "react-router-dom";

import Select from "react-select";
import Toggle from "react-toggle";

import Topo from "../Layout/Topo";
import Overlay from "../Miscelania/Overlay";

class CertificationsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: "",
        type: "",
        status: "open",
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      company_id: null,
      result: null,
      expire: null,
      hours: null,
      internal: false,
      filter_function: false,
      require_grade: false,
      warning_when_expired: false,
      use_data: false,
      deprecated: false,
      schedule_alert: false,
      // certification_type_id: null,
      training_certification_type_id: null,
      // certification_types: [],
      training_certification_types: [],
      companies_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange(name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if (mode === "reset") {
      this.setState({ overlay: { message: "", type: "", status: "closed" } });
    } else {
      this.setState({
        overlay: { message: message, type: type, status: status },
      });
    }
  }
  handleMessage() {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== "undefined") {
      message = JSON.parse(message);
      var self = this;
      self.setState({
        overlay: {
          message: message.alert_message,
          type: message.alert_type,
          status: "open",
        },
      });
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }
  componentDidMount() {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({ loaded: 2 }, this.loadData());
    }
  }
  loadData() {
    var self = this;
    var header = this.refs.request_api.header("application/json");
    Promise.resolve(header).then(function (value) {
      var url = config.get("api") + "/certificados/info/cadastro";
      fetch(url, { method: "GET", mode: "cors", headers: value })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "url");
          if (responseJson.status === "success") {
            self.setState({
              // certification_types: responseJson.data.certification_types,
              training_certification_types:
                responseJson.data.training_certification_types,
            });
          }
        })
        .then(() => {
          var url = config.get("api_sigtrip") + "/empresas/lista";
          fetch(url, { method: "GET", mode: "cors", headers: value })
            .then((response) => response.json())
            .catch((error) => {
              console.error(error);
            })
            .then((responseJson) => {
              self.refs.request_api.validate(responseJson);
              if (responseJson.status === "success") {
                self.setState({ companies_select: responseJson.data });
              }
            })
            .then(() => {
              self.setState({
                overlay: { message: "", type: "", status: "closed" },
              });
            });
        });
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert("", "", "open");
    var datasave = {
      name: this.state.name,
      company_id: this.state.company_id,
      result: this.state.result,
      expire: this.state.expire,
      hours: this.state.hours,
      internal: this.state.internal,
      filter_function: this.state.filter_function,
      require_grade: this.state.require_grade,
      warning_when_expired: this.state.warning_when_expired,
      use_data: this.state.use_data,
      deprecated: this.state.deprecated,
      schedule_alert: this.state.schedule_alert,
      // certification_type_id: this.state.certification_type_id,
      training_certification_type_id: this.state.training_certification_type_id,
    };
    var self = this;
    var header = this.refs.request_api.header("application/json");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/certificado", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          if (responseJson.status === "success") {
            var url = "/certificado/editar/" + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({
            overlay: {
              message: responseJson.message,
              type: responseJson.status,
              status: "open",
            },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar certificado</h3>
      <Link to="/certificados" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome:</label>
              <input type="text" name="name" className="form-control" placeholder="Registro da certificado" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Carga horária:</label>
                <input type="number" value={this.state.hours} name="hours" className="form-control" onChange={this.handleChange.bind(this, 'hours')} placeholder="Carga horária do certificado. Somente números." />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Destinado a:</label>
              <Select
                className="form-field-name"
                name="training_certification_type_id"
                value={this.state.training_certification_type_id}
                searchable={true}
                placeholder={'Selecionar tipo'}
                onChange={this.handleSelectChange.bind(this, 'training_certification_type_id')}
                options={this.state.training_certification_types}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Nota mínima:</label>
              <input type="number" name="result" className="form-control" placeholder="Nota mínima" value={this.state.result} onChange={this.handleChange.bind(this, 'result')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Validade:</label>
            <input type="number" value={this.state.expire} name="expire" className="form-control" onChange={this.handleChange.bind(this, 'expire')} placeholder="Validade em meses do certificado. Somente números." />
          </div>
          <div className="col-md-6 form-group">
            <label>Empresa</label>
            <Select
              className="form-field-name"
              name="company_id"
              value={this.state.company_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'company_id')}
              options={this.state.companies_select}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label>Interno</label>
              <br/>
              <Toggle
                checked={this.state.internal}
                name="internal"
                onChange={this.handleToggleChange.bind(this, 'internal')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>Filtro por função</label>
              <br/>
              <Toggle
                checked={this.state.filter_function}
                name="filter_function"
                onChange={this.handleToggleChange.bind(this, 'filter_function')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>Nota mínima</label>
              <br/>
              <Toggle
                checked={this.state.require_grade}
                name="require_grade"
                onChange={this.handleToggleChange.bind(this, 'require_grade')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>Pesquisa geral</label>
              <br/>
              <Toggle
                checked={this.state.use_data}
                name="use_data"
                onChange={this.handleToggleChange.bind(this, 'use_data')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>Defasado</label>
              <br/>
              <Toggle
                checked={this.state.deprecated}
                name="deprecated"
                onChange={this.handleToggleChange.bind(this, 'deprecated')} />
            </div>
          </div>
          <div className="col-md-2 form-group">
            <label>Alertar na Escala</label>
            <br/>
            <Toggle
              checked={this.state.schedule_alert}
              name="schedule_alert"
              onChange={this.handleToggleChange.bind(this, 'schedule_alert')} />
          </div>
        </div>
        <hr/>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar certificado</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default CertificationsAdd;



// WEBPACK FOOTER //
// ./src/Components/Certifications/CertificationsAdd.js